<template>
  <div class="login-card__reset-password-phone">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.password_reset.phone.header') }}</h1>
      <p class="login-card__title-desc">{{ trans.get('auth.card.password_reset.phone.subheader') }}</p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="phone" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-12">
              <validation-provider name="password" rules="required|confirmed:password_confirmation" v-slot="{ errors }" mode="eager">
                <label for="password"></label>
                <input type="password" id="password" class="input-text input-text__underline" v-model="resetData.password" :placeholder="trans.get('auth.card.fields.new_password')">
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <validation-provider name="password confirmation" rules="required" v-slot="{ errors }" vid="password_confirmation" mode="eager">
                <label for="password-confirmation"></label>
                <input type="password" id="password-confirmation" class="input-text input-text__underline" v-model="resetData.password_confirmation" :placeholder="trans.get('auth.card.fields.new_password_confirmation')">
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <button type="submit" class="button button__fill btn-block mt-5">{{ trans.get('auth.card.buttons.send') }}</button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link button__link--underline mt-3" @click="swapComponent('auth-reset-password-phone-code-card')">{{ trans.get('auth.card.buttons.back') }}</button>

    </div>
  </div>
</template>
<script>
export default {
  props: ['swapComponent', 'form'],
  data: () => ({
    resetData: {
      token: '',
      phone: '',
      password: '',
      password_confirmation: '',
    },
  }),
  methods: {
    onSubmit() {
      const self = this;
      axios
        .post(zRoute('password.update.phone'), this.resetData)
        .then(function (response) {
          window.location.href = zRoute('front.members.index');
        }, function (error) {
          if (error.response.status === 422) {
            self.$refs.form.setErrors(error.response.data.errors);
          }
        });
    },
    getUrlParameters(index) {
      return window.location.href.split('/')[index];
    }
  },
  activated() {
    this.resetData.phone = this.form.phone;
    this.resetData.token = this.form.token.replace(/\s+/g, '');
  }
};
</script>
<style scoped>
</style>
